import { CHANGE_MODAL } from './index'

export const handleModalAction: Types.ActionFactory<boolean> = (payload) => ({
    type: CHANGE_MODAL,
    payload,
})
